module.exports = __webpack_public_path__ + "img/right-grey-lighter-arrow.d85866ca.svg";